<template>
  <div>
    <app-modal :show="true" :styleGotten="modalStyle">
      <div v-if="showModal">
        <p class="form__title">Please set a password</p>
        <form class="set_admin_password_form">
          <div class="">
            <div class="form__group">
              <div class="input_wrap">
                <input
                  :type="showPassword ? 'text ' : 'password'"
                  v-model="password"
                  required
                  placeholder="Password"
                  class="set_password__input"
                />
                <i
                  v-if="showPassword"
                  @click="toggleShowPassowrd"
                  class="fa-regular fa-eye"
                ></i>
                <i
                  v-else
                  class="fa-regular fa-eye-slash view_password_icon"
                  @click="toggleShowPassowrd"
                ></i>
              </div>
              <FormError :validation-msg="validationMsg($v.password)" />
            </div>

            <div class="form__group">
              <div class="input_wrap">
                <input
                  :type="showConfirmPassword ? 'text ' : 'password'"
                  v-model="confirmPassword"
                  required
                  placeholder="Confirm password"
                  class="set_password__input"
                />
                <i
                  v-if="showConfirmPassword"
                  @click="toggleShowConfirmPassowrd"
                  class="fa-regular fa-eye"
                ></i>
                <i
                  v-else
                  class="fa-regular fa-eye-slash view_password_icon"
                  @click="toggleShowConfirmPassowrd"
                ></i>
              </div>
              <FormError :validation-msg="validationMsg($v.confirmPassword)" />
            </div>

            <label for="checkbox" class="remember_password___checkbox">
              <input type="checkbox" id="checkbox" v-model="checkPassword" />
              Remember password
            </label>
          </div>

          <button type="button" class="button_form" @click.prevent="submit">
            <svgicon
              v-if="loading"
              icon="spinner"
              class="button__loader"
            ></svgicon
            >Confirm
          </button>
        </form>
      </div>

      <div v-if="showErrorModal" class="prompt">
        <svg
          width="51"
          height="51"
          viewBox="0 0 51 51"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M25.5 51C39.5833 51 51 39.5833 51 25.5C51 11.4167 39.5833 0 25.5 0C11.4167 0 0 11.4167 0 25.5C0 39.5833 11.4167 51 25.5 51Z"
            fill="#CC1D1D"
          />
          <path
            d="M40.4574 15.1929L36.2464 10.9824L25.7199 21.5094L15.1929 10.9824L10.9824 15.1929L21.5089 25.7199L10.9824 36.2469L15.1929 40.4574L25.7199 29.9304L36.2464 40.4574L40.4574 36.2469L29.9299 25.7199L40.4574 15.1929Z"
            fill="white"
          />
        </svg>
        <h1 class="prompt__title">Oops...</h1>
        <p class="prompt__text">Something went wrong. Let’s try again!</p>
        <div class="btn__wrap">
          <button
            class="button_prompt"
            @click="
              showErrorModal = false;
              showModal = true;
              password = '';
              confirmPassword = '';
            "
          >
            Try Again
          </button>
        </div>
      </div>

      <div v-if="showSuccessModal" class="prompt">
        <svg
          width="66"
          height="66"
          viewBox="0 0 66 66"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M33 66C51.2254 66 66 51.2254 66 33C66 14.7746 51.2254 0 33 0C14.7746 0 0 14.7746 0 33C0 51.2254 14.7746 66 33 66Z"
            fill="#18CE7F"
          />
          <path
            d="M27.9984 50.118L12.7875 34.907C12.5813 34.7008 12.5813 34.3914 12.7875 34.1852L17.1703 29.8023C17.3766 29.5961 17.6859 29.5961 17.8922 29.8023L28.3594 40.2695L48.0562 20.5727C48.2625 20.3664 48.5719 20.3664 48.7781 20.5727L53.1609 24.9555C53.3672 25.1617 53.3672 25.4711 53.1609 25.6773L28.7203 50.118C28.5141 50.3242 28.2047 50.3242 27.9984 50.118Z"
            fill="white"
          />
        </svg>

        <h1 class="prompt__title">Great!</h1>
        <p class="prompt__text">Password has been set successfully.</p>
        <div class="btn__wrap">
          <button class="button_prompt" @click="$router.push('/')">
            Login
          </button>
        </div>
      </div>
    </app-modal>
  </div>
</template>
<script>
import AppModal from "../../resuables/modal.vue";
import { setAdminPassword } from "../../../../services/dashboard";
import { required, helpers } from "vuelidate/lib/validators";
import { validationMessage } from "vuelidate-messages";
import FormError from "../../resuables/form-error.vue";

const formMessages = {
  passwordRequired: () => "Password is required",
  passwordCheck: () =>
    "Password must have at least 8 characters and match the format e.g Abcd123@",
  confirmPasswordRequired: () => "Password must match"
};

const passwordCheck = helpers.regex(
  "password",
  /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z])(?=.*\W).{8,}$/
);

export default {
  components: {
    AppModal,
    FormError
  },
  data() {
    return {
      error: null,
      token: this.$route.params.id,
      loading: false,
      showModal: true,
      checkPassword: false,
      showPassword: false,
      showConfirmPassword: false,
      password: "",
      confirmPassword: "",
      showErrorModal: false,
      showSuccessModal: false,
      errorMessage: "",
      modalStyle: {
        "max-width": "380px",
        width: "100%",
        padding: "40px"
      },
      errorModalStyle: {
        "max-width": "380px",
        width: "100%",
        padding: "40px"
      }
    };
  },
  validations: () => {
    return {
      password: {
        passwordRequired: required,
        passwordCheck
      },
      confirmPassword: {
        confirmPasswordRequired(value) {
          return value === this.password;
        }
      }
    };
  },
  methods: {
    validationMsg: validationMessage(formMessages),
    async submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.error = this.$v;
      } else {
        this.error = null;
        this.errorMessage = "";
        this.loading = true;
        try {
          const response = await setAdminPassword({
            password: this.password,
            token: this.token
          });
          this.loading = false;
          if (response.statusCode === 200) {
            this.showModal = false;
            this.showSuccessModal = true;
            this.$store.dispatch("auth/logout");
            this.$router.push("/");
          } else {
            this.showModal = false;
            this.showErrorModal = true;
          }
        } catch (error) {
          this.loading = false;
          return error;
        }
      }
    },
    validatePassword(password) {
      var upperCaseLetters = /[A-Z]/g;
      var numbers = /[0-9]/g;
      if (password.length < 8) {
        this.errorMessage = "Password must have at least 8 characters";
      } else if (!Boolean(password.match(upperCaseLetters))) {
        this.errorMessage = "Password must have an Upper Case character";
      } else if (!Boolean(password.match(numbers))) {
        this.errorMessage = "Password must have contain a numeric value";
      } else {
        this.errorMessage = "";
      }
    },
    toggleShowPassowrd() {
      this.showPassword = !this.showPassword;
    },
    toggleShowConfirmPassowrd() {
      this.showConfirmPassword = !this.showConfirmPassword;
    }
  }
};
</script>
<style lang="scss" scoped>
p {
  font-family: "Eczar";
  font-weight: 700;
  font-size: 18px;
  color: #0f0c3d;
}

.form__title {
  margin: 0 !important;
  font-size: 22px;
  line-height: normal;
}
.set_admin_password_form {
  margin-top: 10px;
  .form__group {
    margin-bottom: 30px;

    &:last-of-type {
      margin-bottom: 0;
    }
  }
  .input_wrap {
    position: relative;
    input {
      width: 100%;
      border: 1px solid rgba(0, 0, 0, 0.6);
      border-radius: 4px;
      position: relative;
      height: 44px;
      padding: 0 40px 0 10px;
      font-size: 16px;
      line-height: 19px;
      color: rgba(0, 0, 0, 0.8);

      &:focus {
        outline: none;
      }
    }
    .fa-regular {
      position: absolute;
      right: 12px;
      font-size: 20px;
      top: 0;
      bottom: 0;
      margin-top: auto;
      margin-bottom: auto;
      cursor: pointer;
      height: fit-content;
    }
  }
  .set_password_input___container {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .set_password_error_message {
    font-family: "Inter";
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    color: red;
    margin: 10px 0;
  }

  .remember_password___checkbox {
    display: flex;
    align-items: center;
    gap: 5px;
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    color: rgba(0, 0, 0, 0.6);
    margin-top: 18px;
  }
}

.btn__wrap {
  width: 100%;
  display: flex;
  justify-content: center;
}

button {
  max-width: 300px;
  padding: 10px;
  height: 41px;
  font-size: 14px;
  font-weight: 500;
  color: #ffffff;
  background-color: #2e48da;
  border: #fff;
  width: 100%;
  .button__loader {
    width: 20px;
    height: 20px;
  }
  &:disabled {
    cursor: not-allowed;
    opacity: 0.68;
  }

  &.button_prompt {
    width: 143px;
    margin: 0 auto;
    border-radius: 20px;
    margin-top: 16px;
  }
  &.button_form {
    margin-top: 30px;
  }
}

.prompt {
  font-family: "Inter";
  margin: 0 !important;
  width: 100%;
  &__title {
    font-weight: 700;
    font-size: 16px;
    line-height: 20px;
    color: #0e0c0c;
    margin-top: 26px;
  }
  &__text {
    font-family: "Inter";
    font-weight: 400;
    font-size: 14px;
    line-height: 23px;
    color: #3f3d56;
    margin-top: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/authentication/set-password/index.vue